module.exports = __webpack_public_path__ + "img/p1-c2-p4.9290beba.jpg";